import styled, { css } from 'styled-components';

export const AvatarContainer = styled.div`
  position: relative;
  width: 155px;
  height: 155px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Avatar = styled.div`
  position: relative;
  width: 155px;
  height: 155px;
  border-radius: 100px;
  transition: transform 0.04s ease-in-out;
  ${({ theme: { color } }) => css`
    background-color: ${color.blue10};
  `}
`;

export const Initials = styled.div`
  ${({ theme: { font, color } }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    margin-left: auto;
    z-index: 1;
    color: ${color.midnight};
    font: ${font.callout};
    font-size: 2.5rem;
    font-family: 'Ubuntu', sans-serif;
  `}
`;